import { useEffect, useState } from 'react';
import { TABLEAU_EMBED_SCRIPT_URL } from './tableau-constants';

// The embed script defines the <tableau-viz> custom element as a side effect; once defined it
// stays defined for the app's lifetime, so a second mount can just check for it instead of
// re-loading the script.
export const useTableauEmbedScript = (): boolean => {
  const [isLoaded, setIsLoaded] = useState(() => Boolean(customElements.get('tableau-viz')));

  useEffect(() => {
    if (isLoaded) return undefined;

    const existing = document.querySelector<HTMLScriptElement>(
      `script[src="${TABLEAU_EMBED_SCRIPT_URL}"]`
    );
    const script = existing ?? document.createElement('script');
    const onLoad = () => setIsLoaded(true);
    script.addEventListener('load', onLoad);

    if (!existing) {
      script.type = 'module';
      script.src = TABLEAU_EMBED_SCRIPT_URL;
      document.head.appendChild(script);
    }

    return () => script.removeEventListener('load', onLoad);
  }, [isLoaded]);

  return isLoaded;
};
